import React, { useState, useEffect } from "react";
import "./add-affiliates.css";
import DataTable from "react-data-table-component";
import axios from "../../../axios/axios";
import { Button } from "react-bootstrap";
import moment from "moment";
import { message } from "antd";
import { CSVLink } from "react-csv";
import LoadingOverlay from "react-loading-overlay";
import { adminConfig } from "../../../utils/adminConfig";

const customStyles = {
  header: {
    style: {
      minHeight: "56px",
    },
  },
  headRow: {
    style: {
      borderTopStyle: "solid",
      borderTopWidth: "1px",
      backgroundColor: "#004aad",
      borderRadius: "10px 10px 0 0",
    },
  },
  footRow: {
    style: {
      borderTopStyle: "solid",
      borderTopWidth: "1px",
      backgroundColor: "#004aad",
      borderRadius: "10px 10px 0 0",
    },
  },
  headCells: {
    style: {
      "&:not(:last-of-type)": {
        borderRightStyle: "solid",
        borderRightWidth: "1px",
      },
      fontSize: "17px",
      color: "#fff",
      //backgroundColor: "#004aad",
    },
  },

  cells: {
    style: {
      "&:not(:last-of-type)": {
        borderRightStyle: "solid",
        borderRightWidth: "1px",
      },
      fontSize: "16px",
    },
  },
};

const AffiliateTransactionDetails = () => {
  const [commisionList, setcommisionList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [pagination, setPagination] = useState({
    limit: 10,
    page: 1,
    totalPage: 1,
    totalRows: 0,
  });

  const [csvData, setCsvData] = useState([]);

  const getList = async () => {
    setLoading(true);
    try {
      await axios
        .get(`/get-commission-lists?limit=${limit}&page=${page}`, adminConfig())
        .then((res) => {
          setLoading(false);
          setcommisionList(res.data.data);
          setPagination(res.data.pagination);
        })
        .catch((err) => {
          setLoading(false);
          console.log(err);
        });
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  const handlePerRowsChange = (newPerPage) => {
    setLimit(newPerPage);

    setPage(1);
  };

  const changePage = (newPage) => {
    setPage(newPage);
  };

  useEffect(() => {
    getList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, limit]);

  const columns = [
    {
      name: "Date",
      selector: (row) => moment(row.createdAt).format("MM-DD-YYYY"),
      sortable: true,
      width: "130px",
    },
    {
      name: "Affiliate Name",
      selector: (row) => row.user.name,
      sortable: true,
      width: "400px",
    },
    {
      name: "Member Name",
      selector: (row) => row.sourceUser.name,
      sortable: true,
      width: "400px",
    },

    {
      name: "Plan",
      selector: (row) => row.packageName,
      sortable: true,
      width: "350px",
    },
    {
      name: "Commission",
      selector: (row) => row.amount,
      sortable: true,
      width: "150px",
    },
  ];

  const exportCSV = () => {
    setLoading(true);
    axios
      .get(`/get-csv-commission-lists`)
      .then((res) => {
        setLoading(false);
        if (res.data.status) {
          const csvData = res.data.data.map((member) => ({
            Date: moment(member.date).format("MM-DD-YYYY"),
            AffiliateName: member.user.name,
            MemberName: member.sourceUser.name,
            Plan: member.packageName,
            Commission: member.amount,
          }));
          setCsvData(csvData);
          setTimeout(() => {
            document.getElementById("csv-download-link").click();
            setLoading(false);
          }, 2000);
        } else {
          message.error(res.data.message);
        }
      })
      .catch((error) => {
        console.error(error);
        setLoading(false);
      });
  };

  const csvHeaders = [
    { label: "Date", key: "Date" },
    { label: "Affiliate Name", key: "AffiliateName" },
    { label: "Member Name", key: "MemberName" },
    { label: "Plan", key: "Plan" },
    { label: "Commission", key: "Commission" },
  ];

  return (
    <LoadingOverlay active={loading} spinner text="loading...">
      <div className="right_cont">
        <div className="right_banner_banner_cnt">
          <div className="travel_deals_admin">
            <h2>Hello, Admin!</h2>
            <div className="text_field_partts">
              <div className="user_added">
                <div className="ar_count_card d-flex">
                  <h3>Affiliate Transaction Details</h3>
                  <div className="ar_count">{pagination.totalRows}</div>
                </div>

                <div className="filter_section">
                  <div className="filter_btns">
                    <Button
                      className="btn btn-primary search_button"
                      onClick={exportCSV}
                    >
                      Export CSV
                    </Button>
                    <CSVLink
                      data={csvData}
                      headers={csvHeaders}
                      filename={`affiliate_transaction_details.csv`}
                      className="hidden"
                      id="csv-download-link"
                      target="_blank"
                    />
                  </div>
                </div>
                <div className="plan_data">
                  <DataTable
                    columns={columns}
                    data={commisionList}
                    pagination
                    striped
                    responsive
                    customStyles={customStyles}
                    subHeaderAlign="right"
                    subHeaderWrap
                    paginationDefaultPage={page}
                    paginationServer
                    paginationTotalRows={pagination.totalRows}
                    paginationPerPage={limit}
                    paginationRowsPerPageOptions={[10, 15, 20, 40]}
                    onChangeRowsPerPage={handlePerRowsChange}
                    onChangePage={changePage}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </LoadingOverlay>
  );
};

export default AffiliateTransactionDetails;
